import React, { useEffect } from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';
import SubscriptionPlans from './SubscriptionPlans';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 10001;
  padding: ${theme.spacing.xl};
  overflow-y: auto;
`;

const ModalContainer = styled.div`
  background: ${theme.colors.background};
  border-radius: ${theme.borderRadius.xl};
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  margin: ${theme.spacing.xl} 0;
`;

const CloseButton = styled.button`
  position: absolute;
  top: ${theme.spacing.md};
  right: ${theme.spacing.md};
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSizes.xl};
  color: ${theme.colors.text};
  cursor: pointer;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  line-height: 1;
  z-index: 1;
  
  &:hover {
    background: ${theme.colors.surfaceHover};
    border-color: ${theme.colors.primary};
  }
`;

const PlansModal = ({ isOpen, onClose, onPlanSelected }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handlePlanSelected = () => {
    onClose();
    if (onPlanSelected) {
      onPlanSelected();
    }
  };

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <SubscriptionPlans onPlanSelected={handlePlanSelected} />
      </ModalContainer>
    </Overlay>
  );
};

export default PlansModal;
